import React from "react";
import { withTranslation } from "react-i18next";
import get from "lodash/get";
import { getImageFromUrl, getFallbackImageFromUrl } from "../../utils/imageService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons/faTimes";
import noProfile from "../../static/images/no-profile.png";
import BrandificationImageFallback from "../BrandificationImageFallback";
import "./styles.scss";

const LikesList = ({ users, viewProfile, onCancel, t }) => {
  return (
    <div className="likes-modal">
      <div className="modal-header">
        <span className="likes-count">
          {users.length} {users.length > 1 ? t("touchpoint.LikesTotal") : t("touchpoint.LikeTotal")}
        </span>
        <FontAwesomeIcon icon={faTimes} className="close-icon" onClick={onCancel} />
      </div>
      <div className="modal-body">
        {users.map((user, index) => {
          if (user) {
            return (
              <div key={index} className="like-item">
                <BrandificationImageFallback
                  onClick={() => viewProfile(user)}
                  src={getImageFromUrl(get(user, "photoURL"))}
                  fallbackImage={getFallbackImageFromUrl(get(user, "photoURL"), noProfile)}
                  className="user-logo-div"
                />
                <div className="user-info">
                  <div>{user?.name}</div>
                  <span className="user-role">{user?.userRole}</span>
                </div>
              </div>
            );
          } else {
            return null;
          }
        })}
      </div>
    </div>
  );
};

export default withTranslation()(LikesList);
